import {
  createContext,
  useContext,
  useState,
  type ReactNode,
  useMemo,
} from "react";
import { useDisclosure } from "@chakra-ui/react";

export type SimulatorPremisesDrawerContextValue = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
  /** Listado de simulaciones (sin sesión activa): habilita menú y premisas en navbar. */
  listingMode: boolean;
  setListingMode: (value: boolean) => void;
};

const SimulatorPremisesDrawerContext =
  createContext<SimulatorPremisesDrawerContextValue | null>(null);

export function SimulatorPremisesDrawerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const [listingMode, setListingMode] = useState(true);
  const value = useMemo(
    () => ({
      isOpen,
      onOpen,
      onClose,
      onToggle,
      listingMode,
      setListingMode,
    }),
    [isOpen, onOpen, onClose, onToggle, listingMode]
  );
  return (
    <SimulatorPremisesDrawerContext.Provider value={value}>
      {children}
    </SimulatorPremisesDrawerContext.Provider>
  );
}

export function useSimulatorPremisesDrawerOptional() {
  return useContext(SimulatorPremisesDrawerContext);
}

export function useSimulatorPremisesDrawer(): SimulatorPremisesDrawerContextValue {
  const ctx = useContext(SimulatorPremisesDrawerContext);
  if (!ctx) {
    throw new Error(
      "useSimulatorPremisesDrawer debe usarse dentro de SimulatorPremisesDrawerProvider"
    );
  }
  return ctx;
}
